<template>
    <v-app>
        <v-main>
            <v-container
                    class="fill-height"
                    fluid
            >

                <v-row
                        align="center"
                        justify="center"
                        class="mt-12"
                >
                    <v-col
                            cols="6"
                            sm="6"
                            md="4"
                    >
                        <v-img
                                alt="TEAMTRI Logo"
                                contain
                                class="mb-7"
                                src="../assets/tri-logo-large.png"
                                transition="scale-transition"
                                height="60"
                        />
                        <sign-in v-if="formState === 'signIn'" v-on:changeState="changeState"></sign-in>
                        <forgot-password v-if="formState === 'forgotPassword'" v-on:changeState="changeState"></forgot-password>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
    import SignIn from './SignIn';
    import ForgotPassword from './ForgotPassword';

    export default {
        name: 'auth',
        components: {
            SignIn,
            ForgotPassword
        },
        data: () => ({
            formState: 'signIn'
        }),
        methods: {
            changeState(value) {
                this.formState = value
            }
        }
    }
</script>
<style scoped>
    .v-application--wrap {
        min-height: 100vh !important;
    }
</style>